import { get } from '../base';

import { CustomizationResponse } from './types';

export function getProductCustomization({ productId }: { productId: string }) {
  return get(`v5/product-customizations?productId=${productId}`).json<CustomizationResponse>();
}
